<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';
import SectionLayout from '../../../components-next/SectionLayout.vue';
import { useStore } from 'vuex';

const props = defineProps({
  headerTitle: { type: String, default: '' },
  headerButtonText: { type: String, default: '' },
  icon: { type: String, default: '' },
  keepAlive: { type: Boolean, default: true },
  newButtonRoutes: { type: Array, default: () => [] },
  showBackButton: { type: Boolean, default: false },
  backUrl: { type: [String, Object], default: '' },
  showSidemenuIcon: { type: Boolean, default: true },
});

const { t } = useI18n();
const route = useRoute();
const store = useStore();

// Sử dụng route meta để xác định back button
const shouldShowBackButton = computed(() => {
  // Ưu tiên props từ route config
  if (props.showBackButton !== undefined) {
    return props.showBackButton;
  }
  
  return route.meta?.showBackButton || false;
});

const computedBackUrl = computed(() => {
  // Ưu tiên props từ route config
  if (props.backUrl) {
    return props.backUrl;
  }
  
  if (route.meta?.backTo) {
    return { name: route.meta.backTo };
  }
  
  return '';
});

const showNewButton = computed(
  () => props.newButtonRoutes.length !== 0 && !shouldShowBackButton.value
);

// Dynamic title: use integration name on integration details route, else fallback to translated headerTitle
const sectionTitle = computed(() => {
  // Integration details route name per integrations.routes.js
  if (route.name === 'settings_applications_integration') {
    const id = route.params.integration_id;
    if (id) {
      const integration = store.getters['integrations/getIntegration'](id);
      if (integration && integration.name) {
        return integration.name;
      }
    }
  }
  return t(props.headerTitle);
});
</script>

<template>
  <router-view v-if="$route.meta.noWrapper" v-slot="{ Component }">
    <keep-alive v-if="keepAlive">
      <component :is="Component" />
    </keep-alive>
    <component :is="Component" v-else />
  </router-view>

  <SectionLayout 
    v-else 
    :title="sectionTitle" 
    :show-back-button="shouldShowBackButton"
    :back-url="computedBackUrl"
    :has-menu-button="props.showSidemenuIcon"
    class="max-h-screen overflow-y-auto "
  >
    <div class="flex flex-1 h-fit justify-between flex-col m-0">
      <router-view v-slot="{ Component }">
        <keep-alive v-if="keepAlive">
          <component :is="Component" />
        </keep-alive>
        <component :is="Component" v-else />
      </router-view>
    </div>
  </SectionLayout>
</template>